import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/toPromise';
import { map } from 'rxjs/operator/map';
import {AccountService} from './singelton/account.service';
import {isNullOrUndefined} from "@swimlane/ngx-datatable/release/utils";

@Injectable()
export class AppConfigService {

  public version: string;
  public apiEndpointSomeData: string;

  constructor(private http: HttpClient,
              private accountService: AccountService) {}

  load():void  {
    this.accountService.identity(true).then(res=>{console.log(' the resolved account is as follow');});

  }

  // Doing some-thing in application startup
  initializeApp(): Promise<any>{
    return new Promise((resolve, reject) => {
      console.log(`initializeApp:: inside promise`);

      // create time out on startup to prevent frontend hanging in the case of slow internet or backend down
      let timeOut = setTimeout(() => {
        clearTimeout(timeOut);
        //resolve the promise after 10 second to prevent front end hanging
        resolve();
        alert(" internet connection is too slow")
     //    this.toastr.warning('سرعت اینترنت کم میباشد','warning')
      }, 10000)


 //     setTimeout(() => {
        console.log(`initializeApp:: inside setTimeout`);
        // doing something
        this.accountService.identity(true).then(res=>{console.log(' the resolved account is as follow'  + JSON.stringify(res), rej=>{});
        if(!isNullOrUndefined(res))
        this.accountService._connect(res.login)

          // cancel the time out alert if the server response in the less than 10 seconds
          clearTimeout(timeOut);


          // after resolve() of current promise the front application will start to load
          resolve();
        });



        //todo connect & subscribe to notification server if the user is logged In or
        // todo if it is not logged in connect & subscribe after successful authentication

        // the time(in mil-second) app will wait (for server response) before startup
      }, );
  //  });
  }
}
